import {
  HTTP_USERAUTH_FETCHING,
  HTTP_USERAUTH_SUCCESS,
  HTTP_USERAUTH_FAILED,
  HTTP_USERAUTH_CLEAR,
} from "././../../Constants";

const initialState = {
  countries: [],
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_USERAUTH_FETCHING:
      return { ...state, countries: [], isLoading: true, isError: false };
    case HTTP_USERAUTH_SUCCESS:
      return {
        ...state,
        countries: payload,
        isLoading: false,
        isError: false,
      };
    case HTTP_USERAUTH_FAILED:
      return { ...state, countries: [], isLoading: false, isError: true };
    case HTTP_USERAUTH_CLEAR:
      return { ...state, countries: [], isLoading: false, isError: false };
    default:
      return state;
  }
};
